/* eslint-disable no-param-reassign */
import produce from 'immer';
import { REQUEST_CUSTOMERS, GET_CUSTOMERS, SET_CUSTOMERS } from 'src/actions/customerActions';

const initialState = {
  items: [],
  total: 0,
  isFetching: false,
  message: ''
};

const customerReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_CUSTOMERS: {
      return produce(state, (draft) => {
        draft.isFetching = true;
      });
    }

    case GET_CUSTOMERS: {
      const { customers, total, message } = action.payload;

      return produce(state, (draft) => {
        draft.items = customers;
        draft.total = total;
        draft.isFetching = false;
        draft.message = message;
      });
    }

    case SET_CUSTOMERS: {
      const { customers } = action.payload;

      return produce(state, (draft) => {
        draft.items = customers;
      });
    }

    default: {
      return state;
    }
  }
};

export default customerReducer;
